import React from 'react';
import { CheckSquare } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * Widget for Tasks domain navigation card
 * Navigates to tasks view
 */
export default function TasksCardWidget({ onNavigate }) {
  
  return (
    <button
      onClick={() => onNavigate && onNavigate('tasks')}
      style={{
        width: '100%',
        padding: '16px 12px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.15s ease'
      }}
    >
      <CheckSquare size={24} color={ABLE_COLORS.primary} />
      <span style={{
        fontSize: '13px',
        fontWeight: '600',
        color: ABLE_COLORS.textPrimary
      }}>
        Tasks
      </span>
      <span style={{
        fontSize: '10px',
        color: ABLE_COLORS.textMuted
      }}>
        Your to-dos
      </span>
    </button>
  );
}
